import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Badge from '@mui/material/Badge';
import { DashboardTab } from '../Model/CostType';
import { TabDef } from '../Model/Constants';

interface TabBarProps {
  tabs: TabDef[];
  active: DashboardTab;
  onChange: (tab: DashboardTab) => void;
}

const TabBar: React.FC<TabBarProps> = ({ tabs, active, onChange }) => (
  <Tabs value={active} onChange={(x, v) => onChange(v as DashboardTab)}>
    {tabs.map((t) => (
      <Tab
        key={t.id}
        value={t.id}
        label={
          t.badge ? (
            <Badge
              badgeContent={t.badge}
              color="error"
              sx={{
                '& .MuiBadge-badge': { fontSize: 9, height: 16, minWidth: 16 },
              }}
            >
              <span style={{ paddingRight: 8 }}>{t.label}</span>
            </Badge>
          ) : (
            t.label
          )
        }
      />
    ))}
  </Tabs>
);

export default TabBar;
